<template>
  <v-menu
  v-show="notes.length"
  offset-y
  left
  :close-on-content-click="false"
  v-model="menu"
  :disabled="!notes.length"
  lazy
  >
   <v-badge
     right
     overlap
     color="error"
     slot="activator"
     v-model="showBadge"
     >
     <span slot="badge">{{ unreadCount }}</span>
     <v-btn
       icon
       class="mx-0 my-0"
       color="cyan darken-2"
       :disabled="!notes.length"
       flat
       @click.native = "clearUnread"
       :small="dense"
       >
       <v-icon>mdi-message-text</v-icon>
     </v-btn>
   </v-badge>
   <v-card flat>
     <v-list two-line dense>
       <template v-for="(note, index) in notes">
         <v-divider v-if="index > 0" :key="note.id + 'divider'"></v-divider>
         <v-list-tile :key="note.id">
           <v-list-tile-content>
             <v-list-tile-title class="px-0 py-0">
               {{ note.note }}
             </v-list-tile-title>
             <v-list-tile-sub-title>
               <span class="caption grey--text">
                 {{ note.from }} - <timeago
                 :datetime="note.timestamp"
                 :auto-update="60"
                 ></timeago>
               </span>
             </v-list-tile-sub-title>
           </v-list-tile-content>
         </v-list-tile>
       </template>
     </v-list>
   </v-card>
  </v-menu>
</template>

<script>
import { get, sortBy } from 'lodash/fp'
import firebase from '@/firebase'
import '@firebase/firestore'

const db = firebase.firestore()
const CLEAR_UNREAD_TIME = 2000

export default{
  name: 'NotesTableIcon',
  props: {
    docId: String,
    dense: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menu: false,
      notes: []
    }
  },
  computed: {
    notesRef () { return db.collection('notes') },

    unreadCount () {
      // console.log('UNREAD COUNT: ', this.notes)
      return this.notes.filter(note => {
        // console.log('NOTE: ', note)
        return note.readBy ? !note.readBy[this.user.uid] : true
      }).length
    },

    showBadge () { return this.unreadCount > 0 },

    user () {
      return this.$store.getters['user/saveUser']
    }
  },
  methods: {
    fetchData () {
      this.notesRef
        .where('doc', '==', this.docId)
        .onSnapshot(querySnapshot => {
          const notes = []
          querySnapshot.forEach(doc => {
            notes.push({
              ...doc.data(),
              id: doc.id
            })
          })
          this.notes = sortBy(note => note.timestamp)(notes)
        }, error => {
          console.log('Error Notes Table Icon snapshot', error)
        })
    },

    // Clears all unread flags for the opened notes
    clearUnread () {
      // console.log('clearUnread for notes: ', this.notes)
      // console.log('this', this)
      // Start a timer that clears the unread after two seconds
      setTimeout(() => {
        const uid = this.$store.getters['user/user'].uid

        const batch = db.batch()

        // For each note, check if the current users uid is present in the readBy map
        this.notes.forEach(note => {
          const noteRef = this.notesRef.doc(note.id)
          const hasRead = get(['readBy', uid])(note)
          if (!hasRead) {
            // If it isn't, add it
            batch.update(noteRef, {
              [`readBy.${uid}`]: true
            })
          }
        })

        batch.commit()
          .then(() => {
            console.log('Note successfully updated!')
          })
          .catch(error => {
            console.error('error updating Note: ', error)
          })
      }, CLEAR_UNREAD_TIME)
    }
  },
  created () {
    // console.log('NOTES TABLE ICON CREATED', this)
    // console.log('FOR DOC:', this.docId)
    this.fetchData()
  }
}
</script>

<style scoped>
</style>
